import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { UserMenuService } from './user-menu.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserMenuComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  islogoutOfAllSessions: boolean = false;
  agencyName: string;
  OnboardUserName: string
  constructor(public global: GlobalComponent, private router: Router, public UMS: UserMenuService, public toasterService: ToastrService) { }

  ngOnInit() {

    let userNames = localStorage.getItem("fms_Username");
    let roles = localStorage.getItem("fms_roles");
    if (userNames != null) {
      this.global.logginedUserName = userNames;
      this.global.globalroleName = roles;
    }
    if(roles==null || roles==undefined ||roles=='')
      {
        let agencyCode = localStorage.getItem("fms_agencyCode")
        this.global.globalroleName = agencyCode;
      }
    if (this.global.OnboardingLoginType == "onboardLogin") {
      this.global.onboardUserName = localStorage.getItem("fms_onboardusername");
      this.global.onboardRoles = localStorage.getItem("onboardLoginUser")
      this.OnboardUserName = localStorage.getItem("onboardLoginUserName")



    }
    let agencydetails = JSON.parse(localStorage.getItem("fms_globalagencydetails"));

    if (agencydetails != null) {
      this.agencyName = agencydetails.agencyName;
      this.global.globalAgencyName = agencydetails.agencyName
      this.global.globalAgencyDropdown = agencydetails.agencyId
    }
  }
  clearBoolean() {

    if (this.global.OnboardingLoginType == "onboardLogin") {
      this.islogoutOfAllSessions = true;
    }
    else {
      this.islogoutOfAllSessions = false;
    }
  }
  routeToActiveSession() {
    this.islogoutOfAllSessions = false;
    this.router.navigateByUrl("/active-session");
  }
  logoutSession() {
    if (this.islogoutOfAllSessions == true) {
      this.islogoutOfAllSessions = true;
    }
    else {
      this.islogoutOfAllSessions = false;
    }
    if (this.global.OnboardingLoginType == "agencyLogin") {
      this.UMS.logoutSession(this.islogoutOfAllSessions).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toasterService.success('Logout Successful');
        this.global.LogoutFunction();
      },
        (err: HttpErrorResponse) => {

          this.global.LogoutFunction();
        })
    }
    else if (this.global.OnboardingLoginType == "onboardLogin") {

      this.toasterService.success('Logout Successful');
      this.global.LogoutFunction();

    }
  }
}